import { Partners } from '../types/partners'
import { isPartner } from './isPartner'

export const getPartnerByString = (stringPartner: string | undefined) => {
  if (isPartner(stringPartner as string)) {
    return stringPartner
  }

  return Partners.DEFAULT
}
